import { Component, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-top',
  standalone: true,
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss'],
})
export class TopComponent {
  @ViewChild('videoPlayer') videoPlayer?: ElementRef<HTMLVideoElement>
  constructor(private router: Router) {}
  environmentKey: 'prod' | 'dev' | null =
    environment.environmentCd === 'prod' ? 'prod' : environment.environmentCd === 'dev' ? 'dev' : null
  iconUrl: string = 'assets/img/icon_biz-marche_c.png'

  currentStep = 0
  isVideoSwitching = false
  isInitialVideoReady = false
  private hasInitialLoaded = false
  private readonly fadeDuration = 350
  // 現在は暫定で画像を表示しており、動画は未使用（walking4/hanabi2/petabo.mp4 は削除済み）。
  // 新しい動画ができたらここに入れ、テンプレート側のコメントアウトを戻す。
  videoUrls: string[] = []

  // Getterの名前を変更
  get currentVideoUrl() {
    return this.videoUrls[this.currentStep] || 'assets/placeholder.mp4'
  }
  // 動画が終了した時に呼ばれる
  onVideoEnded() {
    const nextIndex = (this.currentStep + 1) % this.videoUrls.length
    this.switchVideo(nextIndex)
  }

  goToVideo(index: number) {
    if (index === this.currentStep) return
    this.switchVideo(index)
  }

  onVideoLoaded() {
    const video = this.videoPlayer?.nativeElement
    if (video) {
      const playPromise = video.play()
      if (playPromise) {
        playPromise.catch(() => {})
      }
    }

    if (!this.hasInitialLoaded) {
      this.hasInitialLoaded = true

      window.setTimeout(() => {
        this.isInitialVideoReady = true
      }, 100)

      return
    }

    requestAnimationFrame(() => {
      this.isVideoSwitching = false
    })
  }

  private switchVideo(nextIndex: number) {
    this.isVideoSwitching = true

    window.setTimeout(() => {
      this.currentStep = nextIndex

      const video = this.videoPlayer?.nativeElement
      if (!video) return

      video.load()
    }, this.fadeDuration)
  }

  nextStep() {
    if (this.currentStep < this.videoUrls.length - 1) {
      this.switchVideo(this.currentStep + 1)
    }
  }

  clickRegister() {
    // アカウントタイプ（管理者/一般）はログイン後の初期設定で決めるため、ここでは選ばせずアカウント登録へ進む
    this.router.navigate(['/registration'])
  }

  clickLogin() {
    // ログイン画面へ遷移（遷移先は環境設定から取得）
    location.href = environment.login.isbeLogin
  }
}
